import { LayoutPage } from '@/components/hoc';
import { useDocumentTitle } from '@/hooks';
import { Outlet } from 'react-router-dom';
import { useTabSelected } from './hooks';
import { Settings } from 'lucide-react';
import { Menus } from './components';
import routes from '@/lib/routes';

const SettingsPage = () => {

  const { title, tabSelected } = useTabSelected();
  useDocumentTitle({
    title: (
      tabSelected === 'permissions'
        ? 'Paramètres des permissions'
        : tabSelected === 'audit-logs'
          ? "Journaux d'audit"
          : tabSelected === 'payment-providers'
            ? 'Moyens de paiement'
            : 'Outils dans les paramètres'
    )
  });

  return (
    <LayoutPage
      header={{
        description: 'Gestion des paramètres et autres opérations sur le système.',
        title: 'Paramètres'
      }}
      breadcrumb={{
        title,
        subMenus: [{
          href: routes.nav.settings.permissions.path,
          title: 'Paramètres',
          menus: ([
            tabSelected !== 'permissions' &&
            {
              href: routes.nav.settings.permissions.path,
              title: `Permissions`
            },
            tabSelected !== 'tools' &&
            {
              href: routes.nav.settings.tools.path,
              title: `Outils`
            }
          ]).filter(Boolean) as { href: string; title: string }[]
        }]
      }}
      icon={Settings}>
      <div className='pt-3 md:pt-5'>
        <div className='flex flex-col space-y-8 md:flex-row md:space-x-12 md:space-y-0'>
          <Menus />
          <div className='flex-1'>
            <Outlet />
          </div>
        </div>
      </div>
    </LayoutPage >
  );

};

export default SettingsPage;
